import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./detailpage.css";

import arthroBanner from "../../images/arthoscopy-drape-banner.avif";
import arthroone from "../../images/pdpimage/arthoone.jpg";
import arthodrapetwo from "../../images/pdpimage/arthotwo.jpg";
import arthrothree from "../../images/pdpimage/arthothree.jpg";
import arthrofour from "../../images/pdpimage/orthofour.jpg";

const whatsappNumber = "+919619065205";

const ContactBanner = () => (
  <div className="contact-banner">
    <h3>Need guidance choosing the right drape?</h3>
    <p>Our clinical support team is here to assist you.</p>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Bulk Quote
    </a>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Brochure
    </a>
  </div>
);

const ArthroscopyDrape = () => {
  const [mainImage, setMainImage] = useState(arthroone);
  const thumbnails = [arthroone, arthodrapetwo, arthrothree, arthrofour];

  useEffect(() => {
    document.title =
      "Arthroscopy Drape - Efficient Fluid Management for Joint Procedures";
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section
        className="homepage-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${arthroBanner})`,
        }}
      >
        <h1 className="homepage-hero-title">Arthroscopy Drape</h1>
        <p className="homepage-hero-subtext">
          Efficient Fluid Management for Minimally Invasive Joint Procedures
        </p>
        <div className="homepage-hero-buttons">
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Bulk Quote
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Brochure
          </a>
        </div>
      </section>

      {/* Product Overview */}
      <section className="mw-product-details mw-container">
        <div className="mw-gallery">
          {/* Main Image */}
          <div className="mw-gallery-main">
            <img
              src={mainImage}
              alt="Arthroscopy Drape"
              className="main-gallery-image"
            />
          </div>

          {/* Thumbnails */}
          <div className="mw-gallery-thumbs">
            {thumbnails.map((img, index) => (
              <div
                key={index}
                className={`gallery-thumb-img-box ${
                  mainImage === img ? "active-thumb" : ""
                }`}
                onClick={() => setMainImage(img)}
              >
                <img src={img} alt={`Thumbnail ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        <div className="mw-product-info" id="contact">
          <h2 className="homepage-section-title">Product Overview</h2>
          <p>
            Designed for arthroscopic surgeries of the knee, shoulder, and other
            joints, our Arthroscopy Drapes ensure fluid control, clear access,
            and maximum sterility during minimally invasive procedures.
            Integrated pouches collect irrigation fluid and allow suction
            placement.
          </p>
          <ul className="mw-list">
            <li>Transparent fluid pouch for effective collection</li>
            <li>Elastic fenestration for joint site access</li>
            <li>High absorbency and impermeable zones</li>
            <li>Secure adhesive strips for patient positioning</li>
            <li>Sterile, ready-to-use format</li>
          </ul>

          <h2 className="homepage-section-title">Technical Specifications</h2>
          <table className="mw-specs-table">
            <thead>
              <tr>
                <th>Parameter</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Material</td>
                <td>SMS/SMMS with PE film &amp; fluid pouch</td>
              </tr>
              <tr>
                <td>Size</td>
                <td>200 x 240 cm / 180 x 200 cm (customizable)</td>
              </tr>
              <tr>
                <td>Fenestration</td>
                <td>Elastic circular/oval opening</td>
              </tr>
              <tr>
                <td>Accessories</td>
                <td>Transparent pouch, tubing port, suction port</td>
              </tr>
              <tr>
                <td>Packaging</td>
                <td>1 pc per pouch, 20 pcs/carton</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Compliance */}
      <section className="mw-compliance">
        <h2 className="homepage-section-title">Certifications & Standards</h2>
        <ul className="mw-cert-list">
          <li>
            <span className="checkmark">✅</span> ISO 13485:2016
          </li>
          <li>
            <span className="checkmark">✅</span> EN 13795 High Performance
          </li>
          <li>
            <span className="checkmark">✅</span> MDR Compliant
          </li>
        </ul>
      </section>

      {/* Footer CTA */}
      <ContactBanner />
    </>
  );
};

export default ArthroscopyDrape;
